'use strict';

import {
  apiUrl
} from '../../app/app.api.config';

export function UserResource($resource) {
  'ngInject';
  return $resource(apiUrl().API_URL + '/me', {
  }, {
    changePassword: {
      method: 'PUT',
      params: {
        controller: 'password'
      }
    },
    get: {
      method: 'GET'
    }
  });
}



// WEBPACK FOOTER //
// ./client/components/auth/user.service.js